import React from 'react';
import { displayName } from '../../../../App';
import MainInfoTracLayout from '../../../components/Layout/Main';
import Content from '../../../components/Pages/AccountManagement/CreateAccount';
import AccountManagementProvider from '../../../context/accountManagement';

function AccountManagementCreateAccount() {
  document.title = `${displayName}: Account Management: Create Account`;

  return (
    <MainInfoTracLayout className="min-h-screen">
      <AccountManagementProvider>
        <Content />
      </AccountManagementProvider>
    </MainInfoTracLayout>
  );
}

export default AccountManagementCreateAccount;
